import { ViewModel,View, Component } from "binder"
import  { BarcodeReaderView } from "./barcodeReader-view"
import { stringIsNullOrEmpty } from "src/common/utilities";

export class BarcodeReaderViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.audio = new Audio('/res/sounds/Barcode-scanner-beep-sound.mp3');
    }
    GetDefaultView(): View <ViewModel> {
        return new BarcodeReaderView();
    }
    public getTypeId(): string {
        return "VM-CFE5BE57-EDE0-4535-9531-7174AD129997"
    }
    private audio;    
    public set readcode(v: string) { 
        if(stringIsNullOrEmpty(v)==false)
            this.audio.play();
        if(stringIsNullOrEmpty(v)==false){
            this.text = `${v}`
            console.log(this.text);
        }
        this._readcode = `${v}`;
    } public get readcode(): string { return this._readcode;} private _readcode: string;

    public set text(v: string) { this._text = v; } public get text(): string { return this._text;} private _text: string;
}
